export default __webpack_public_path__ + "static/fingerprint-bg-57cedeeaf56698807dc2f52eacbd006c.svg";